<template>
    <div>
        <!-- 基本信息 -->
        <div class="inputList">

            <labelInput :outInput="newform.name" :spanRequired="true" normalPlace="请输入"
                        @inputChange="labelInput($event,'company_name')"
                        spanTitle="工法名称" :spanWidth="spanWidth" componentWidth="90%">
            </labelInput>

            <div style="display: flex;flex-wrap: wrap;margin-top: 20px;">

                <normalSelect   :spanRequired="true"
                                pelaceHolder='请选择'
                                :spanWidth="spanWidth" @selectCode="typeThreeInput($event,'1')"
                                :dataList="installList2" componentWidth="500px" spanTitle="类别">
                </normalSelect>

                <normalSelect   :spanRequired="true"installList3
                                pelaceHolder='请选择'
                                :spanWidth="spanWidth" @selectCode="typeThreeInput($event,'2')"
                                :dataList="installList3" componentWidth="500px" spanTitle="专业分类">
                </normalSelect>
            </div>


            <div style="display: flex;flex-wrap: wrap;margin-top: 20px;">

                <normalSelect   :spanRequired="true"
                                pelaceHolder='请选择'
                                :spanWidth="spanWidth" @selectCode="typeThreeInput($event,'3')"
                                :dataList="installList1" componentWidth="500px" spanTitle="申报推荐地区">
                </normalSelect>

                <normalSelect   :spanRequired="true"
                                pelaceHolder='请选择注册地'
                                :spanWidth="spanWidth" @selectCode="typeThreeInput($event,'4')"
                                :dataList="installList4" componentWidth="500px" spanTitle="注册地">
                </normalSelect>
            </div>


            <div style="display: flex;flex-wrap: wrap;margin-top: 20px;">

                <normalSelect   :spanRequired="true"
                                pelaceHolder='请选择'
                                :spanWidth="spanWidth" @selectCode="typeThreeInput($event,'5')"
                                :dataList="installList5" componentWidth="500px" spanTitle="是否为升级版工法">
                </normalSelect>

                <normalSelect   :spanRequired="true"
                                pelaceHolder='请选择注册地'
                                :spanWidth="spanWidth" @selectCode="typeThreeInput($event,'6')"
                                :dataList="installList5" componentWidth="500px" spanTitle="是否包含专利">
                </normalSelect>
            </div>


            <p class="view_head midflex">主要完成人</p>

            <labelInput :outInput="newform.complete_collect" :spanRequired="true" normalPlace="请输入"
                        @inputChange="labelInput($event,'contacts_name')"
                        spanTitle="主要完成人汇总" :spanWidth="spanWidth" componentWidth="520px">
            </labelInput>

            <div style="display: flex;flex-wrap: wrap;margin-top: 20px;">

                <labelInput :outInput="newform.contacts_post" :spanRequired="true" normalPlace="请输入"
                            @inputChange="labelInput($event,'contacts_post')"
                            spanTitle="姓名" :spanWidth="spanWidth" componentWidth="520px">
                </labelInput>

                <labelInput :outInput="newform.contacts_phone" :spanRequired="true" normalPlace="请输入"
                            @inputChange="labelInput($event,'contacts_phone')"
                            spanTitle="工作单位" :spanWidth="spanWidth" componentWidth="520px"
                            >
                </labelInput>
                <labelInput :outInput="newform.contacts_phone"  normalPlace="请输入"
                            @inputChange="labelInput($event,'contacts_phone')"
                            spanTitle="职务" :spanWidth="spanWidth" componentWidth="520px"
                            >
                </labelInput>
                <labelInput :outInput="newform.contacts_phone"  normalPlace="请输入"
                            @inputChange="labelInput($event,'contacts_phone')"
                            spanTitle="职称" :spanWidth="spanWidth" componentWidth="520px"
                            >
                </labelInput>
                <labelInput :outInput="newform.contacts_phone" :spanRequired="true" normalPlace="请输入"
                            @inputChange="labelInput($event,'contacts_phone')"
                            spanTitle="电话" :spanWidth="spanWidth" componentWidth="520px"
                          >
                </labelInput>
            </div>

            <!-- 主要经营管理指标统计 -->
            <p class="view_head midflex">工法应用工程情况</p>

            <div>
                <labelInput :outInput="newform.contacts_phone" :spanRequired="true" normalPlace="请输入"
                            @inputChange="labelInput($event,'contacts_phone')"
                            spanTitle="工程名称" :spanWidth="spanWidth" componentWidth="520px"
                           >
                </labelInput>

                <div style="display: flex;flex-wrap: wrap;margin-top: 20px;">
                    <labelInput :outInput="newform.contacts_phone" :spanRequired="true" normalPlace="请输入"
                                @inputChange="labelInput($event,'contacts_phone')"
                                spanTitle="开竣工时间" :spanWidth="spanWidth" componentWidth="520px"
                                >
                    </labelInput>


                    <normalSelect   :spanRequired="true"
                                    pelaceHolder='工程所在地区'
                                    :spanWidth="spanWidth" @selectCode="typeThreeInput($event,'11')"
                                    :dataList="installList4" componentWidth="500px" spanTitle="工程所在地区">
                    </normalSelect>

                </div>
                <labelInput :outInput="newform.contacts_phone" :spanRequired="true" normalPlace="请输入"
                            @inputChange="labelInput($event,'contacts_phone')"
                            spanTitle="工程照片 " :spanWidth="spanWidth" componentWidth="520px"
                           >
                </labelInput>

            </div>

            <!-- 主要经营管理指标统计 -->
            <p class="view_head midflex">工法内容简介</p>

            <labelInput :outInput="newform.content1" :spanRequired="true" normalPlace="请输入"
                        @inputChange="labelInput($event,'contacts_phone')"
                        spanTitle="工法关键技术名称、组织审定单位和时间" :spanWidth="spanWidth" componentWidth="520px"
                       >
            </labelInput>

            <labelInput :outInput="newform.content2"  normalPlace="请输入"
                        @inputChange="labelInput($event,'contacts_phone')"
                        spanTitle="工法关键技术获科技成果奖励的情况" :spanWidth="spanWidth" componentWidth="520px"
            >
            </labelInput>

            <labelInput :outInput="newform.content3"  normalPlace="请输入"
                        @inputChange="labelInput($event,'contacts_phone')"
                        spanTitle="工法形成企业技术标准情况" :spanWidth="spanWidth" componentWidth="520px"
            >
            </labelInput>

            <labelInput :outInput="newform.content4"  normalPlace="请输入"
                        @inputChange="labelInput($event,'contacts_phone')"
                        spanTitle="升级版工法原工法编号、名称、完成单位及批准文号（升级版工法填写此栏）" :spanWidth="spanWidth" componentWidth="520px"
            >
            </labelInput>

            <labelInput :outInput="newform.content5"  normalPlace="请输入"
                        @inputChange="labelInput($event,'contacts_phone')"
                        spanTitle="工法摘要（300字以内）" :spanWidth="spanWidth" componentWidth="520px"
            >
            </labelInput>


            <labelInput :outInput="newform.content6" normalPlace="请输入"
                        @inputChange="labelInput($event,'contacts_phone')"
                        spanTitle="工法关键词" :spanWidth="spanWidth" componentWidth="520px"
            >
            </labelInput>

            <labelInput :outInput="newform.content7"  normalPlace="请输入"
                        @inputChange="labelInput($event,'contacts_phone')"
                        spanTitle="工法内容简述" :spanWidth="spanWidth" componentWidth="520px"
            >
            </labelInput>

            <labelInput :outInput="newform.content8"  normalPlace="请输入"
                        @inputChange="labelInput($event,'contacts_phone')"
                        spanTitle="关键技术及保密点" :spanWidth="spanWidth" componentWidth="520px"
            >
            </labelInput>


            <labelInput :outInput="newform.content9"  normalPlace="请输入"
                        @inputChange="labelInput($event,'contacts_phone')"
                        spanTitle="技术水平和技术难度（包括与省内外同类技术水平比较）" :spanWidth="spanWidth" componentWidth="520px"
            >
            </labelInput>

            <labelInput :outInput="newform.content10"  normalPlace="请输入"
                        @inputChange="labelInput($event,'contacts_phone')"
                        spanTitle="工程应用情况及推广应用前景" :spanWidth="spanWidth" componentWidth="520px"
            >
            </labelInput>

            <labelInput :outInput="newform.content11" normalPlace="请输入"
                        @inputChange="labelInput($event,'contacts_phone')"
                        spanTitle="经济效益或社会效益（包括节能和环保效益）" :spanWidth="spanWidth" componentWidth="520px"
            >
            </labelInput>


            <!-- 主要经营管理指标统计 -->
            <p class="view_head midflex">涉及专利的工法应填写下列内容</p>

            <div>
                <div style="display: flex;flex-wrap: wrap;margin-top: 20px;">
                    <labelInput :outInput="newform.contacts_phone" normalPlace="请输入"
                                @inputChange="labelInput($event,'contacts_phone')"
                                spanTitle="专利名称" :spanWidth="spanWidth" componentWidth="520px"
                    >
                    </labelInput>

                    <labelInput :outInput="newform.contacts_phone"  normalPlace="请输入"
                                @inputChange="labelInput($event,'contacts_phone')"
                                spanTitle="专利号及专利有效期" :spanWidth="spanWidth" componentWidth="520px"
                    >
                    </labelInput>

                    <labelInput :outInput="newform.contacts_phone"  normalPlace="请输入"
                                @inputChange="labelInput($event,'contacts_phone')"
                                spanTitle="专利权人姓名" :spanWidth="spanWidth" componentWidth="520px"
                    >
                    </labelInput>

                    <normalSelect   :spanRequired="true"
                                    pelaceHolder='企业专利或职工专利'
                                    :spanWidth="spanWidth" @selectCode="typeThreeInput($event,'12')"
                                    :dataList="installList7" componentWidth="500px" spanTitle="企业专利或职工专利">
                    </normalSelect>

                </div>

                <labelInput :outInput="newform.contacts_phone"  normalPlace="请输入"
                            @inputChange="labelInput($event,'contacts_phone')"
                            spanTitle="许可使用（有偿或无偿）范围、期限、权限" :spanWidth="spanWidth" componentWidth="520px"
                >
                </labelInput>
            </div>



        </div>

    </div>
</template>

<script>
    import labelInput from '../../../components/table/labelInput.vue'
    import normalPicker from '../../../components/table/normalPicker.vue'

    import normalSelect from '../../././../components/table/normalSelect.vue'

    import {

        getWinningInfo

    } from '../../../api/moudles/manager.js'

    import {
        API_DOMAIN
    } from '../../../api/api.js'


    import {saveQua, setBasicProgram} from "../../../api/moudles/manager";
    import labelText from '../../../components/table/labelText.vue'

    export default {
        data() {
            return {

                spanWidth: '180px',
                newform:{

                    name:'',
                    category:'',
                    major_category:'',
                    recommend_area:'',
                    register_area:'',
                    is_pro:'',
                    has_patent:'',
                    completeForm:{
                        username:'',
                        unit:'',
                        post:'',
                        title:'',
                        phone:'',
                    },
                    content1: '',
                    content2: '',
                    content3: '',
                    content4: '',
                    content5: '',
                    content6: '',
                    content7: '',
                    content8: '',
                    content9: '',
                    content10: '',
                    content11: '',

                    applicationForm:{
                        project_name:'',
                        start_work:'',
                        where:'',
                        photo:'',
                    },

                    patentForm:{
                        patent_name:'',
                        patent_num:'',
                        patent_man_name:'',
                        patent_enp:'',
                        range:'',

                    }
                },
                addList:[],

                installList5:[
                    [{
                        name: '是',
                        code: '1'
                    }, {
                        name: '否',
                        code: '0'
                    }
                    ]
                ],

                installList7:[
                    [{
                        name: '企业专利',
                        code: '企业专利'
                    }, {
                        name: '职工专利',
                        code: '职工专利'
                    }
                    ]
                ],


                installList2:[
                    [{
                        name: '房屋建筑工程',
                        code: '房屋建筑工程'
                    }, {
                        name: '市政公用工程',
                        code: '市政公用工程'
                    }, {
                        name: '机电安装工程',
                        code: '机电安装工程'
                    },
                        {
                            name: '行业工法（申请认定）',
                            code: '行业工法（申请认定）'
                        },
                    ]
                ],

                installList4:[
                    [{
                        name: '福州市',
                        code: '福州市'
                    }, {
                        name: '厦门市',
                        code: '厦门市'
                    }, {
                        name: '泉州市',
                        code: '泉州市'
                    },
                        {
                            name: '漳州市',
                            code: '漳州市'
                        }, {
                        name: '莆田市',
                        code: '莆田市'
                    },{
                        name: '龙岩市',
                        code: '龙岩市'
                    },{
                        name: '三明市',
                        code: '三明市'
                    },{
                        name: '南平市',
                        code: '南平市'
                    },{
                        name: '宁德市',
                        code: '宁德市'
                    },{
                        name: '平潭综合实验区',
                        code: '平潭综合实验区'
                    },{
                        name: '福建省外',
                        code: '福建省外'
                    },

                    ]
                ],

                installList1:[
                    [{
                        name: '福州市',
                        code: '福州市'
                    }, {
                        name: '厦门市',
                        code: '厦门市'
                    }, {
                        name: '泉州市',
                        code: '泉州市'
                    },
                        {
                            name: '漳州市',
                            code: '漳州市'
                        }, {
                        name: '莆田市',
                        code: '莆田市'
                    },{
                        name: '龙岩市',
                        code: '龙岩市'
                    },{
                        name: '三明市',
                        code: '三明市'
                    },{
                        name: '南平市',
                        code: '南平市'
                    },{
                        name: '宁德市',
                        code: '宁德市'
                    },{
                        name: '平潭综合实验区',
                        code: '平潭综合实验区'
                    },{
                        name: '直属申报',
                        code: '直属申报'
                    },

                    ]
                ],


                installList3:[
                    [{
                        name: '城市道路',
                        code: '城市道路'
                    }, {
                        name: '桥梁',
                        code: '桥梁'
                    }, {
                        name: '隧道',
                        code: '隧道'
                    },
                    {
                        name: '城市轨道交通',
                        code: '城市轨道交通'
                    },
                    ]
                ],
                oldAddList: [],

                form: {
                    company_name: '',
                    contacts_name: '',
                    contacts_post: '',
                    contacts_phone: '',
                    cellphone: '',
                    liability_ratio: '',
                    profit_rate: '',
                    growth_rate: '',




                },
            }
        },
        components: {
            labelInput,
            normalPicker,
            labelText,
            normalSelect
        },
        props: {
            // 切换基本信息和获奖信息
            isBasic: {
                type: Boolean,
                default: true
            },
            project_app_num: {
                type: String,
                default: ''
            },

            basicMsg: {
                type: Object,
                default: () => {
                    return {}
                }
            },
            awardMsg: {
                type: Array,
                default: () => {
                    return []
                }
            }
        },
        watch: {
            basicMsg(newvalue) {
                this.newform = {
                    ...newvalue
                }
            },

            awardMsg(newvalue) {

                console.log(4444)
                console.log(newvalue)
                console.log(8888)

                this.oldAddList = newvalue
            }
        },
        created() {
            if (this.isBasic) {
                this.$emit('basicInfo', this.form)
            }
        },
        methods: {


            // 提交获奖信息
            async getWinninginfo() {

                const params = {
                    ...this.levelOne
                }

                if (this.project_app_num) {
                    params.project_app_num = this.project_app_num
                }

                let newAddList = [...this.addList, ...this.oldAddList]
                for (let item in newAddList) {
                    if (!newAddList[item].qualification_category || !newAddList[item].qualification_level) {
                        this.$message.error('未填写完整')
                        return
                    }
                }

                params.awardJson = newAddList

                await saveQua({
                    data: params,
                    success: res => {
                        if (res.code === 200) {
                            this.$message({
                                message: res.msg,
                                type: 'success'
                            });
                            //this.project_app_num = res.data.project_app_num
                        } else {
                            // this.project_app_num = res.data.project_app_num
                            this.$message.error(res.msg)
                        }
                    }
                })

            },


            // 新增参建单位输入
            typeThreeInput(e, type) {
                if (type == '1') {
                    this.newform.category = e
                } else if(type == '2'){
                    this.newform.major_category = e
                }else if(type == '3'){
                    this.newform.recommend_area = e
                }else if(type == '4'){
                    this.newform.register_area = e
                }else if(type == '5'){
                    this.newform.is_pro = e
                }else if(type == '6'){
                    this.newform.has_patent = e
                }
            },
            // 新增参建单位
            addInstall() {
                this.addList.push({})
            },
            // 删除行
            deleteList(index, type) {
                const number = this.addList.length + this.oldAddList.length
                if (number === 1) {
                    this.$message.error(`至少填写一条参建信息`)
                    return
                }
                if (type === '1') {
                    // 例旧信息
                    this.oldAddList.splice(index, 1)
                } else {
                    this.addList.splice(index, 1)
                }

            },

            labelInput(e, name) {
                this.form[name] = e
                this.$emit('basicInfo', this.form)
            },
            labelInput2(e, name, id) {
                const params = [id, name, e]
                this.$emit('awardInfo', params)
            }
        }
    }
</script>

<style scoped>
    .midflex {
        width: 100%;
        text-align: center;
        margin-bottom: 20px;
    }

    .inputList {
        display: flex;
        flex-wrap: wrap;
        margin-top: 20px;
    }

    .view_head {
        font-size: 18px;
        font-weight: 600;
        margin-top: 20px;
    }

    .titleLeft {
        margin-left: 50px;
    }

    .awardInfo {
        display: flex;
        flex-wrap: wrap;
        margin-top: 20px;
    }

    /* 提示 */
    .allTips {
        margin: 20px 0;
        padding-left: 80px;
        text-align: left;
    }

    .tipList {
        /* margin-left: 80px; */
        display: flex;
        justify-content: flex-start;
    }

    .tipList p {
        display: inline-block;
        text-align: left;
        line-height: 25px;
    }

    .tipList p:nth-child(1) {
        width: 80px;
    }

    .tipList p:nth-child(2) {
        width: 200px;
    }

    .tipList p:nth-child(3) {
        width: 350px;
    }
</style>
